// extracted by mini-css-extract-plugin
export default {"checkbox":"MassUpdateCheckbox_checkbox__omMZn"};